import { OrderStatus } from './Order'
import {
  AdjudicationTriageReasons,
  AutomationTriageReasons,
  CommonOrderTriageReasons,
  FillTriageReasons,
  ManualTestingTriageReasons,
  MiscellaneousTriageReasons,
  OrderTriageReasons,
  PV1TriageReasons,
  PV1TriageReasonsRestricted,
  PV2TriageReasons,
} from './Triage'

export const triageReasonsByStatus = new Map<OrderStatus, string[]>([
  [
    OrderStatus.Adjudication,
    [
      ...Object.values(AdjudicationTriageReasons),
      ...Object.values(ManualTestingTriageReasons),
      OrderTriageReasons.ReplacementOrder,
    ],
  ],
  [OrderStatus.Automation, [...Object.values(AutomationTriageReasons), ...Object.values(ManualTestingTriageReasons)]],
  [
    OrderStatus.PriorAuthorization,
    [...Object.values(AdjudicationTriageReasons), ...Object.values(ManualTestingTriageReasons)],
  ],
  [
    OrderStatus.PV1,
    [
      ...Object.values(PV1TriageReasonsRestricted),
      ...Object.values(PV1TriageReasons).filter(
        triageReason => triageReason !== PV1TriageReasons.PatientOutreachRequired,
      ),
      FillTriageReasons.OOS,
      FillTriageReasons.NeedsReplenishment,
      OrderTriageReasons.ReplacementOrder,
      ...Object.values(ManualTestingTriageReasons),
      ...Object.values(CommonOrderTriageReasons),
    ],
  ],
  [
    OrderStatus.Fill,
    [
      ...Object.values(FillTriageReasons),
      ...Object.values(ManualTestingTriageReasons),
      ...Object.values(CommonOrderTriageReasons),
    ],
  ],
  [
    OrderStatus.PV2,
    [
      ...Object.values(PV2TriageReasons),
      ...Object.values(ManualTestingTriageReasons),
      ...Object.values(CommonOrderTriageReasons),
    ],
  ],
  [
    OrderStatus.Packing,
    [
      OrderTriageReasons.OOS,
      MiscellaneousTriageReasons.Other,
      FillTriageReasons.WeatherDelay,
      ...Object.values(ManualTestingTriageReasons),
    ],
  ],
])

// Triage reasons displayed only for orders with OTC products (OTC-only and Rx+OTC), added to the triage reasons list above.
export const otcTriageReasonsByStatus = new Map<OrderStatus, string[]>([
  [OrderStatus.Packing, [OrderTriageReasons.InvalidAddress, OrderTriageReasons.NeedsReplenishment]],
])

export const getTriageReasonsByStatus = (status: OrderStatus, hasOtc = false): string[] | undefined => {
  const reasons = triageReasonsByStatus.get(status)
  const otcReasons = hasOtc ? otcTriageReasonsByStatus.get(status) ?? [] : []
  if (!reasons && !otcReasons.length) return undefined
  return [...new Set([...(reasons ?? []), ...otcReasons])]
}
